// Signup-resume landing: the universal login (app.reachiq.ai) redirects an
// account-in-progress user here with their draft details in the query string.
// We rebuild the durable signup state and drop them on their exact pending step.
// The draft_id doubles as the bearer secret (same value the verification email
// link carries) — an invalid/expired one just falls back to a fresh signup.
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  SIGNUP_PATH,
  PLAN_PATH,
  CREATE_WORKSPACE_PATH,
  VERIFY_EMAIL_PENDING_PATH,
} from "../../utils/constants/routes";
import { saveSignupState, loadSignupState } from "../../utils/helpers/signupState";

const STEP_ROUTES = {
  "set-plan": PLAN_PATH,
  "set-subdomain": CREATE_WORKSPACE_PATH,
  "verify-email": VERIFY_EMAIL_PENDING_PATH,
};

const ResumeScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const draft_id = params.get("draft_id") || "";
    const step = params.get("step") || "";
    const email = params.get("email") || "";
    const firstName = params.get("first_name") || "";
    const lastName = params.get("last_name") || "";
    const tenant_url = params.get("tenant_url") || "";

    if (!draft_id || !STEP_ROUTES[step]) {
      navigate(SIGNUP_PATH, { replace: true });
      return;
    }
    saveSignupState({
      ...loadSignupState(),
      draft_id,
      ...(email ? { email } : {}),
      ...(firstName ? { firstName } : {}),
      ...(lastName ? { lastName } : {}),
      ...(tenant_url ? { tenant_url } : {}),
    });
    navigate(STEP_ROUTES[step], {
      replace: true,
      state: { draft_id, email, firstName, lastName },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default ResumeScreen;
